import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const APP_CACHE_VERSION = "solar-data-noaa-v2";

try {
  const previousVersion = localStorage.getItem("radiodx_app_cache_version");
  if (previousVersion !== APP_CACHE_VERSION) {
    localStorage.setItem("radiodx_app_cache_version", APP_CACHE_VERSION);
    localStorage.removeItem("radiodx_lastSolarData");

    if ("caches" in window) {
      caches.keys().then((keys) => {
        keys
          .filter((key) => key.includes("noaa") || key.includes("hamqsl") || key.includes("workbox"))
          .forEach((key) => caches.delete(key));
      });
    }
  }
} catch {
  // Cache reset best-effort: non deve mai bloccare il rendering dell'app.
}

// Service Worker update listener - auto-reload on new version
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistration().then((registration) => registration?.update());
  });

  navigator.serviceWorker.ready.then((registration) => {
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      if (newWorker) {
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'activated' && navigator.serviceWorker.controller) {
            // New SW activated and there was a previous one — reload
            window.location.reload();
          }
        });
      }
    });
  });
}

createRoot(document.getElementById("root")!).render(<App />);
